export type CsBroadcastPayload = {
  title: string;
  body: string;
  imageUrl?: string;
  imageUrls?: string[];
};

export function resolveCsBroadcastImageUrls(payload: CsBroadcastPayload): string[] {
  const fromList = (payload.imageUrls ?? [])
    .map((u) => String(u ?? "").trim())
    .filter(Boolean);
  if (fromList.length > 0) return fromList;
  const single = String(payload.imageUrl ?? "").trim();
  return single ? [single] : [];
}

export function parseCsBroadcastContent(content: string): CsBroadcastPayload | null {
  if (!content?.trim()) return null;
  try {
    const raw = JSON.parse(content) as Partial<CsBroadcastPayload> & { imageUrls?: unknown };
    const title = String(raw.title ?? "").trim();
    const body = String(raw.body ?? "").trim();
    const imageUrl = String(raw.imageUrl ?? "").trim();
    const imageUrls = Array.isArray(raw.imageUrls)
      ? raw.imageUrls.map((u) => String(u ?? "").trim()).filter(Boolean)
      : [];
    if (!title && !body && !imageUrl && imageUrls.length === 0) return null;
    return {
      title,
      body,
      imageUrl: imageUrl || undefined,
      imageUrls: imageUrls.length > 0 ? imageUrls : undefined,
    };
  } catch {
    return null;
  }
}

export function truncateCsBroadcastBody(body: string, max = 50): string {
  const text = body.trim();
  if (text.length <= max) return text;
  return `${text.slice(0, max)}...`;
}
